import { set } from 'date-fns';
import React, { useState, useContext } from 'react'
import {ThemeContext} from '../Helper/Context'

const Selectchild = ({handleDashboard, handleEditChild}) => {
    
    const {mainState, setMainState} = useContext(ThemeContext);
    const handleSelectChild = (e, id) =>{

        mainState.children.map((child, index)=>{
            mainState.children[index].selected = false;
            if(id === child.id){
                mainState.children[index].selected = true;
            }
        })
        setMainState({...mainState});
    }

    const hidePopup = (e) =>{
        if(e.target.className.indexOf('perfectgym-popup') !== -1){
            handleDashboard(false, false, false)
          }
    }

    const EditChild = (e, id) =>{
        handleDashboard(false, false, false, true);
        handleEditChild(e, id);
        
    }
    
    return (
        <div className="perfectgym-popup edit-popup" onClick={e=>{hidePopup(e)}}>
            <div className="popup-content">
            <div className="closebtn" onClick={(e) => handleDashboard(false, false, false)}><i className="fal fa-times"></i></div>
                <h2>Select your child</h2>
                <div className="child-list-wrapper">
                    <ul>
                        {mainState.children.map((child, index)=>{
                        return(
                            <li key={index} className={`${child.selected ? 'selected' : ''}`}>
                                <span>{child.firstName}</span>
                                <div className="action-btns">
                                    {/* <button className="btn btn-border" onClick={e => EditChild(e, child.id)}>Edit</button> */}
                                    {/* <button disabled className="btn btn-border">Edit</button> */}
                                    <button className="btn" onClick={e => handleSelectChild(e, child.id)}>{child.selected ? 'Selected': 'Select'}</button>
                                </div>
                            </li>
                            )
                        })}
                        
                    </ul>
                </div>
                <div className="linkwrapper">
                    <button className="btn btn-border" onClick={(e) => handleDashboard(false, true, false)}>add more</button>
                    { mainState.children.filter(e => e.selected === true).length > 0 &&
                    <button className="btn btn-right" onClick={(e) => handleDashboard(false, false, false)}>next</button>
                    }
                </div>
            </div>
        </div>
    )
}

export default Selectchild
